/**
 * Singapura — AR Verification of Data chatflow. title → 회사 선택 → confirm (person/date/address 플러밍은
 *   형제 aura agm 플로우 재사용). id·taskCode·환영문만 별도.
 */
import type { ConversationMessage } from '@/features/AI-documents/types/docGen.types';
import type { ChatFlow } from '@/features/startTask/preset_task/shared/preset/chatflows/types';
import type { PreSetSelection } from '@/features/startTask/preset_task/shared/preset/types/preset.types';
import { auraAgmFlow } from '../../aura/agm/chatflows/auraAgmFlow';

export const singapuraVerificationFlow: ChatFlow = {
  ...auraAgmFlow,
  id: 'singapura-verification',
  taskCodeMatch: ['CSI001'],
  categoryMatch: ['verification', 'verification of data', 'annual return', 'ar'],

  getInitialMessages(_preSet: PreSetSelection): ConversationMessage[] {
    return [
      {
        role: 'ai',
        content:
          `Welcome to **Singapura — Verification of Data** (Annual Return).\n\n` +
          `This preset prepares the AR data-verification form: company particulars, registered office, ` +
          `charges, share capital, principal activity, company-size tests, and the particulars of directors, ` +
          `officers, auditors and shareholders — to be verified and confirmed by the director.\n\n` +
          `First, enter a **Task Title**, then select the **company**.`,
        timestamp: Date.now(),
        stepId: 1,
        source: 'system',
      },
    ];
  },
};
